import type { IconName } from '@shared/components'
import { USER_TYPES } from '@core/data/models'

interface NavItem {
  label: string
  active_icon: IconName
  inactive_icon: IconName
  route?: string
  extras?: boolean
  allowedTypes?: USER_TYPES[]
}

export const navItems: NavItem[] = [
  {
    label: 'CAMERINO',
    active_icon: 'camerino_active',
    inactive_icon: 'camerino_inactive',
    route: '/championships'
  },
  {
    label: 'EQUIPO',
    active_icon: 'equipo_active',
    inactive_icon: 'equipo_inactive',
    route: '/team',
    allowedTypes: [USER_TYPES.GERENTE, USER_TYPES.SUPERVISOR, USER_TYPES.JEFE]
  },
  {
    label: 'TIROS LIBRES',
    active_icon: 'tiros_libres_active',
    inactive_icon: 'tiros_libres_inactive',
    route: '/tiros-libres'
  },
  {
    label: 'TIENDA',
    active_icon: 'tienda_active',
    inactive_icon: 'tienda_inactive',
    route: '/tienda'
  },
  {
    label: 'SALA DE TROFEOS',
    active_icon: 'polla_active',
    inactive_icon: 'polla_inactive',
    route: '/sala_de_trofeos',
    allowedTypes: [USER_TYPES.PILOTO, USER_TYPES.SUPERVISOR, USER_TYPES.JEFE]
  },
  {
    label: 'EXTRAS',
    active_icon: 'extras_active',
    inactive_icon: 'extras_inactive',
    extras: true
  }
]

export function getVisibleNavItems(userType?: USER_TYPES | null): NavItem[] {
  return navItems.filter(item => !item.allowedTypes || (userType != null && item.allowedTypes.includes(userType)))
}
